import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * 初期型
 */
export interface ABTestState {
  ruijiRecommendGroupNo: number;
  abTestForManuscriptEGroupNo: number;
  topCounselingTodoListTextAbGroupNo?: string | null;
  memberRegistrationSuggestionBannerGroupNo?: string | null;
}

/**
 * Slice型
 */
export interface ABTestSliceState {
  abTest: ReturnType<typeof abTestReducer>;
}

export const ABTestForManuscriptEPattern = {
  Original: 1,
  A: 2,
  B: 3,
  Ineligible: 999,
} as const;

/**
 * 初期状態
 */
export const abTestInitialState: ABTestState = {
  ruijiRecommendGroupNo: 1,
  abTestForManuscriptEGroupNo: ABTestForManuscriptEPattern.Ineligible,
  topCounselingTodoListTextAbGroupNo: '0',
  memberRegistrationSuggestionBannerGroupNo: '0',
};

/**
 * slice
 */
const abTestSlice = createSlice({
  name: 'abTest',
  initialState: abTestInitialState,
  reducers: {
    setRuijiRecommendGroupNo: (state, action: PayloadAction<number>) => {
      state.ruijiRecommendGroupNo = action.payload;
    },
    setAbTestForManuscriptEGroupNo: (
      state,
      action: PayloadAction<ABTestState['abTestForManuscriptEGroupNo']>
    ) => {
      state.abTestForManuscriptEGroupNo = action.payload;
    },
    setTopCounselingTodoListTextGroupNo: (
      state,
      action: PayloadAction<ABTestState['topCounselingTodoListTextAbGroupNo']>
    ) => {
      state.topCounselingTodoListTextAbGroupNo = action.payload;
    },
    setMemberRegistrationSuggestionBannerGroupNo: (
      state,
      action: PayloadAction<
        ABTestState['memberRegistrationSuggestionBannerGroupNo']
      >
    ) => {
      state.memberRegistrationSuggestionBannerGroupNo = action.payload;
    },
  },
});

export const {
  setRuijiRecommendGroupNo,
  setAbTestForManuscriptEGroupNo,
  setTopCounselingTodoListTextGroupNo,
  setMemberRegistrationSuggestionBannerGroupNo,
} = abTestSlice.actions;

export const abTestReducer = abTestSlice.reducer;

type State = ABTestSliceState;

/**
 * Selector ruijiRecommendGroupNoSelector
 * @param state
 * @returns ruijiRecommendGroupNo
 */
export const ruijiRecommendGroupNoSelector = <S extends State>(state: S) =>
  state.abTest.ruijiRecommendGroupNo;

/**
 * Selector abTestForManuscriptEGroupNoSelector
 * @param state
 * @returns abTestForManuscriptEGroupNo
 */
export const abTestForManuscriptEGroupNoSelector = <S extends State>(
  state: S
) => state.abTest.abTestForManuscriptEGroupNo;

/**
 * Selector topCounselingTodoListTextGroupNoSelector
 * @param state
 * @returns topCounselingTodoListTextAbGroupNo
 */
export const topCounselingTodoListTextGroupNoSelector = <S extends State>(
  state: S
) => state.abTest.topCounselingTodoListTextAbGroupNo;

/**
 * Selector memberRegistrationSuggestionBannerGroupNoSelector
 * @param state
 * @returns memberRegistrationSuggestionBannerGroupNo
 */
export const memberRegistrationSuggestionBannerGroupNoSelector = <
  S extends State,
>(
  state: S
) => state.abTest.memberRegistrationSuggestionBannerGroupNo;
